module.exports = __webpack_public_path__ + "static/media/IMG_0878.d284de1f.jpg";